export default __webpack_public_path__ + "static/media/bg2.a9ad3491.png";